import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as SociosCrud from 'services/socio.service'

const RucFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, vRuc }) => {
  const [opcionesBotonBuscar, setOpcionesBotonBuscar] = React.useState({
    buscando: false,
    texto: 'Buscar'
  })

  const __zariContext = React.useContext(ZariContext)

  const clickBuscarSocioHandler = async () => {
    setOpcionesBotonBuscar({
      buscando: true,
      texto: 'Buscando...'
    })
    await SociosCrud.getSocioViaSunat(vRuc)
      .then(({ data }) => {
        setFieldValue('razonSocial', data.razonSocial)
        setFieldValue('direccion', data.direccion)
        setFieldValue('_idDepartamento', data._idDepartamento)
        setFieldValue('_idProvincia', data._idProvincia)
        setFieldValue('_idDistrito', data._idDistrito)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        setOpcionesBotonBuscar({
          buscando: false,
          texto: 'Buscar'
        })
      })
  }

  return (
    <Form.Group>
      <Form.Label text='RUC' htmlFor='input-ruc' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputGroup>
          <Field name='ruc'>{({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled id='input-ruc' />}</Field>
          <Form.InputGroup.Append>
            <Button disabled={fIsSubmitting || opcionesBotonBuscar.buscando} onClick={clickBuscarSocioHandler}>
              {opcionesBotonBuscar.texto}
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RucFormGroup)
